module.exports = __webpack_public_path__ + "img/adv-mapIcon23.84560d51.png";